import React from 'react';
import {msToTime} from "../../helpers/helpers";
import { ClockProps } from "./types";

const Clock = ({ elapsed, live } : ClockProps) => { // elapsed in miliseconds

  return <label className="l-03"
                style={{
                  left: !live ? '0px' : '',
                  color: !live ? '#333d47' : '',
                  paddingLeft: live ? '0px' : '15px'
                }}>
    {!live && <span>PRACTICE COMPLETE</span>}
    <i style={{color: !live ? '#4F9300' : ''}} className="mdi mdi-alarm"/>
    {msToTime(elapsed)}
  </label>;
};

export default Clock;
